const RICH_TEXT_REGEX = /<\/?(?:strong|em|a)[^>]*>/g;

export const removeRichTextMarkup = (item) => item.replace(RICH_TEXT_REGEX, '');
export const removeRichTextMarkupFromItems = (items) => items?.map(removeRichTextMarkup);
